export enum FollowUps {
  MANAGE_ENTITY_FOLLOW_UP_DRAWER = "MANAGE_ENTITY_FOLLOW_UP_DRAWER",
}
